/*globals ScrollMagic*/

if ($('.floating-summary').length) {
    var floatingSummaryController = new ScrollMagic.Controller();
    // fix the header
    new ScrollMagic.Scene({
        triggerHook: '0',
        // offset: -10,
        triggerElement: '.floating-summary'
    })
        .setPin('.floating-summary .summary')
        .setClassToggle('.floating-summary', 'pinned')
        .addTo(floatingSummaryController);   
}